import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GhostBlock } from "@faire/retailer-visitor-shared/components/GhostLoading/GhostBlock";
import { EAEAEA_PIXEL } from "@faire/retailer-visitor-shared/consts/EAEAEA_PIXEL";
import { Column, Flex, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import range from "lodash/range";
import React from "react";
import styled from "styled-components";
export var FilmstripBrandListSkeleton = function() {
    return /*#__PURE__*/ _jsx("div", {
        "data-test-id": "filmstrip-brand-list-skeleton",
        children: range(0, 4).map(function(index) {
            return /*#__PURE__*/ _jsx(FilmstripBrandSkeleton, {
                row: index
            }, index);
        })
    });
};
var FilmstripBrandSkeleton = function(param) {
    var row = param.row;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        direction: {
            mobileAndAbove: "column",
            tabletAndAbove: "row"
        },
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                align: "center",
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: EAEAEA_PIXEL,
                        style: {
                            width: "88px",
                            height: "88px",
                            borderRadius: "50%"
                        }
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsxs(Column, {
                        children: [
                            /*#__PURE__*/ _jsx(GhostBlock, {
                                $width: "64px",
                                $height: "20px"
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "1x"
                            }),
                            /*#__PURE__*/ _jsx(GhostBlock, {
                                $width: "192px",
                                $height: "20px"
                            }),
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "1x"
                            }),
                            /*#__PURE__*/ _jsx(GhostBlock, {
                                $width: "208px",
                                $height: "20px"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Row, {
                align: "center",
                gap: "1x",
                children: range(0, 3).map(function(index) {
                    return /*#__PURE__*/ _jsx("img", {
                        src: EAEAEA_PIXEL,
                        style: {
                            width: "142px",
                            height: "142px"
                        }
                    }, "".concat(row, " ").concat(index));
                })
            })
        ]
    });
};
var Wrapper = styled(Flex).withConfig({
    componentId: "sc-e1a5327c-0"
})([
    "cursor:progress;overflow:hidden;padding:",
    ";",
    "{padding:",
    ";}"
], getSpacing("3x", 0), responsiveMediaQueries.tabletAndAbove, getSpacing("6x", 0));
